import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';
import {
  CommonSection,
  ContentContainer
} from '~/components/flp/Financing.styles';

export const CustomizeYourDealSection = createComponent(CommonSection, {
  className: 'bg-canvas-muted'
});

export const Content = createComponent(ContentContainer, {
  className: 'flex w-full flex-col gap-5xl'
});

export const Controls = createComponent<
  ElementWithProps<{ showFourCards: boolean }>
>('div', ({ showFourCards }) => ({
  className: cx(
    'grid grid-cols-1 gap-2xl sm:grid-cols-2',
    showFourCards
      ? 'xl:grid-cols-4'
      : 'md:grid-cols-3 [&>div:first-child]:sm:col-span-2 [&>div:first-child]:md:col-span-1'
  )
}));
